import {
  GEOLOCATION_REQUEST_OPTIONS,
  HOTEL_NEARBY_LOCATION_ERROR,
} from '../constants/hotelSearch.constants';

let inFlightPermissionRequest = null;

function messageForGeolocationError(error) {
  if (!error) return HOTEL_NEARBY_LOCATION_ERROR;
  if (error.code === 1) return 'Location access denied. Please allow location access and try again.';
  if (error.code === 2) return 'Location information is unavailable. Please try again.';
  if (error.code === 3) return 'Location request timed out. Please try again.';
  return error.message || HOTEL_NEARBY_LOCATION_ERROR;
}

function isGeolocationSupported() {
  return typeof navigator !== 'undefined' && Boolean(navigator.geolocation);
}

/**
 * Shows the browser's native location-permission dialog (Chrome/Safari/Edge).
 * `getCurrentPosition` is the API that actually prompts; Permissions.query does not.
 */
export function getCurrentCoordinates() {
  return new Promise((resolve, reject) => {
    if (!isGeolocationSupported()) {
      reject(new Error('Location is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        reject(new Error(messageForGeolocationError(error)));
      },
      GEOLOCATION_REQUEST_OPTIONS,
    );
  });
}

export function requestBrowserLocationPermission() {
  if (inFlightPermissionRequest) return inFlightPermissionRequest;

  inFlightPermissionRequest = getCurrentCoordinates().finally(() => {
    inFlightPermissionRequest = null;
  });

  return inFlightPermissionRequest;
}

export function promptBrowserLocationPermission() {
  return requestBrowserLocationPermission().catch(() => null);
}
